module.exports = __webpack_public_path__ + "static/media/wirebit-logo.57390174.svg";